import React, { memo } from 'react';
import { navIconMap } from './nav-icon-map.js';
export { navIconMap } from './nav-icon-map.js';
import './style.css.js';

const Icon = memo(({ active, kind, ...rest }) => {
  const Icon2 = navIconMap[kind];
  return /* @__PURE__ */ React.createElement(Icon2, {
    className: active ? "mds-icons-nav-active" : "mds-icons-nav",
    ...rest
  });
});

export { Icon };
//# sourceMappingURL=index.js.map
